// Shared inspector header: eyebrow date label (signal when today), Fraunces
// 24 title, optional right-aligned status.

import type { ReactNode } from 'react';
import { C, FONT_DISPLAY } from '../../lib/design';
import { isoToday } from '../../lib/day-data';
import { dayLabel } from '../../lib/ledger';
import { Lbl } from './ui';

export function InspHead({ date, title, right }: { date: string; title: ReactNode; right?: ReactNode }) {
  const today = date === isoToday();
  return (
    <div
      style={{
        padding: '14px 16px',
        borderBottom: `1px solid ${C.line}`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        gap: 12,
      }}
    >
      <div style={{ minWidth: 0 }}>
        <Lbl color={today ? C.signal : C.dim}>
          {today ? 'TODAY · ' : ''}
          {dayLabel(date)}
        </Lbl>
        <div style={{ fontFamily: FONT_DISPLAY, fontSize: 24, marginTop: 6, letterSpacing: '-0.01em' }}>{title}</div>
      </div>
      {right}
    </div>
  );
}
